import type { SvgIconProps } from '@mui/material/SvgIcon';

import { GeneralIcon } from 'assets/images/documents';

import { fileTypeToIconMap } from './functions';

export function FileIcon({
	mimeType,
	...props
}: {
	mimeType: string;
} & SvgIconProps): React.JSX.Element {
	const FileTypeIcon = fileTypeToIconMap[mimeType] || GeneralIcon;
	return <FileTypeIcon {...props} />;
}
